<div
  id="lead-source-modal"
  role="dialog"
  aria-labelledby="leadSourceModalLabel"
>
  <div class="modal-dialog modal-dialog-centered modal-lg">
    <div class="modal-content">
      <div class="modal-header">
        <h4 class="modal-title" id="leadSourceModalLabel">
          {{ "kanban.selectLossReason.title" | translate }}
        </h4>
        <button
          type="button"
          class="btn-close"
          data-bs-dismiss="modal"
          aria-hidden="true"
          (click)="close()"
        ></button>
      </div>

      <div class="modal-body">
        <form [formGroup]="formGroup">
          <div class="row mt-3">
            <div class="col-xs-12 mb-3">
              <label class="form-label">{{
                "kanban.selectLossReason.lossReasonLabel" | translate
              }}</label>
              <mat-select
                formControlName="lossReason"
                class="form-control"
                [placeholder]="
                  'kanban.selectLossReason.lossReasonPlaceholder' | translate
                "
              >
                <div class="overflow-auto">
                  @if (lossReasonList.length === 0) {
                    <mat-option disabled>
                      {{
                        "kanban.selectLossReason.noLossReasonFound" | translate
                      }}
                    </mat-option>
                  }
                  @for (item of lossReasonList; track $index) {
                    <mat-option [value]="item._id">
                      @if (item.platform) {
                        {{ discardLabel(item) | translate }}
                        <span
                          class="badge bg-soft-secondary text-muted ms-1 font-11"
                          >{{
                            "kanban.lossReason.platformBadge" | translate
                          }}</span
                        >
                      } @else {
                        {{ item.name }}
                      }
                    </mat-option>
                  }
                </div>

                <div class="d-flex justify-content-end p-1 border-top bg-white">
                  <button
                    class="btn btn-outline-light"
                    (click)="
                      $event.stopPropagation();
                      $event.preventDefault();
                      createLossReason()
                    "
                  >
                    <i class="mdi mdi-plus me-1"></i>
                    <span>{{
                      "kanban.selectLossReason.newLossReason" | translate
                    }}</span>
                  </button>
                </div>
              </mat-select>
            </div>
          </div>

          <!-- The note is mandatory for a platform discard reason and only then (E3 RF-24, AC-33). -->
          @if (selectedIsPlatform) {
            <div class="mb-3">
              <label class="form-label" for="lossNote">{{
                "kanban.selectLossReason.note" | translate
              }}</label>
              <textarea
                id="lossNote"
                class="form-control"
                rows="3"
                formControlName="lossNote"
              ></textarea>
              <span class="help-block"
                ><small class="text-muted">{{
                  "kanban.selectLossReason.noteHint" | translate
                }}</small></span
              >
            </div>
          }

          <!-- RF-26/AC-20: a blacklist discard also blacklists the contact — the impact is stated before confirming. -->
          @if (selectedIsBlacklist && blacklistImpact !== null) {
            <div class="alert alert-warning py-2 mb-0" role="alert">
              <i class="mdi mdi-alert-outline me-1"></i>
              {{
                "kanban.selectLossReason.blacklistImpact"
                  | translate: { deals: blacklistImpact }
              }}
            </div>
          }
        </form>
      </div>

      <div class="modal-footer">
        <button type="button" class="btn btn-outline-light" (click)="close()">
          {{ "kanban.selectLossReason.close" | translate }}
        </button>
        <button
          type="button"
          class="btn btn-primary"
          [disabled]="loading"
          (click)="save()"
        >
          @if (loading) {
            <span
              class="spinner-border spinner-border-sm me-2"
              role="status"
              aria-hidden="true"
            ></span>
          } @else {
            {{ "kanban.selectLossReason.save" | translate }}
          }
        </button>
      </div>
    </div>
  </div>
</div>
